<!--
 * @Author: cryi.liu
 * @Date: 2020-06-04 09:56:17
 * @LastEditTime: 2020-06-04 10:58:58
 * @Description: pdf 预览
-->
<template>
  <div id="pdf-preview" @contextmenu.prevent>
    <div v-if="loadedProgress !== 100" class="progress-bar">
      <div class="progress-bar-inner" :style="{ width: `${loadedProgress}%` }"></div>
    </div>
    <pdf
      class="pdf-item"
      v-for="i in totalPage"
      :key="i"
      :src="realUrl"
      :page="i"
      @page-loaded="pdfPageLoaded"></pdf>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import pdf from 'vue-pdf';

export default {
  name: 'PdfPreview',
  components: {
    pdf,
  },
  props: {
    url: { type: String, required: true },
  },
  data() {
    return {
      realUrl: '',
      totalPage: 0,
      loadedPage: 0,
      loadedProgress: 0,
    };
  },
  computed: {
    pdfSupport() {
      return this.$pdf.supportsPDFs;
    },
  },
  methods: {
    ...mapActions({
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
    }),
    /**
     * 解码base64 url
     */
    decodeBase64Url() {
      this.realUrl = this.$base64.decode(this.url);
    },
    /**
     * 加载pdf预览
     */
    loadPdfPreview() {
      if (this.pdfSupport) {
        this.$nextTick(() => {
          this.$pdf.embed(this.realUrl, '#pdf-preview');
        });
      } else {
        alert('该浏览器不支持pdf预览');
      }
    },
    pdfPageLoaded() {
      this.loadedPage += 1;

      this.loadedProgress = (this.loadedPage / this.totalPage) * 100;
    },
  },
  created() {
    this.setProcessingShowState({ show: false });

    this.decodeBase64Url();

    pdf.createLoadingTask(this.realUrl).promise.then((result) => {
      this.totalPage = result._pdfInfo.numPages;
    });
  },
  // beforeMount() {
  //   this.loadPdfPreview();
  // },
};
</script>

<style lang="less" scoped>
#pdf-preview {
  width: 100%;
  height: 100%;
  padding: 120px;
  box-sizing: border-box;
  overflow-x: hidden;
  background-color: #535659;

  @media screen and (max-width: 1280px) and (min-width: 960px) {
    padding: 80px;
  }

  @media screen and (max-width: 960px) {
    padding: 60px;
  }

  .pdf-item {
    margin: 0 auto;
    width: 85%;
    max-width: 1280px;
    margin-bottom: 26px;

    @media screen and (max-width: 1280px) and (min-width: 960px) {
      width: 90%;
    }

    @media screen and (max-width: 960px) {
      width: 100%;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .progress-bar {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3000;
    width: 100%;
    height: 4px;

    &-inner {
      width: 0%;
      height: 100%;
      border-radius: 4px;
      background-color: #047dee;
      transition: all .32s linear;
    }
  }
}
</style>
